import React from "react";
import "./stat.css";

function Stat({ name, base, mod, tooltip, className }) {
    const getModifierClass = (mod) => {
        if (mod > 0) return 'sgreen';
        if (mod < 0) return 'sred';
        return '';
    };
    
    const displayName = (name === "Gold") ? "Gold" : name;
    
    let valueColor = 'var(--theme-text)';
    if (name === "Gold") {
        valueColor = '#ffd700'; // Gold color
    } else if (name === "Armour") {
        valueColor = '#a0a0a0'; // Gray color
    }
    
    return (
        <div className={`statbox ${className || ''}`} data-tooltip={tooltip}>
            <div className="stat-item key" style={{ color: 'var(--theme-primary)' }}>
                {displayName}
            </div>
            <div className="stat-controls">
                <div className="stat-item">
                    <span className="stat-value" style={{ color: valueColor }}>
                        {base}
                    </span>
                </div>
                <div className="stat-modifier-container">
                    {mod !== 0 ? (
                        <span className={getModifierClass(mod)}>
                            {mod > 0 ? '+' : ''}{mod}
                        </span>
                    ) : (
                        <span className="empty-mod"></span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Stat;